export default __webpack_public_path__ + "static/media/vroom.3708cf99.png";